import { useMemo } from 'react';

import EntryPointsHelper from '@/utils/entry-points-helper';

const useDataBrandFamily = () => {
	const brandFamilyAttribute = useMemo(() => {
		const attribute = 'data-brand-family';
		return document
			.querySelector(`main[${attribute}]`)
			?.getAttribute(attribute)
			?.toLowerCase();
	}, []);

	const thirdPartyBrandFamily = useMemo(() => {
		const attribute = 'data-brand-logo';
		return EntryPointsHelper.entryPoint
			?.getAttribute(attribute)
			?.toLowerCase()
			.replace('-', '');
	}, []);

	return brandFamilyAttribute ?? thirdPartyBrandFamily;
};

export default useDataBrandFamily;
